import Axios from "axios";
import { BaseService } from "./BaseService";

BaseService.loadAxios();

export class IdiomaService{
    public static async cargarIdiomas(){
        return await Axios.get('admin/idiomas');
    }

    public static async cambiarIdioma(id: string){
        return await Axios.post('admin/idioma/' + id);
    }
}